import * as React from "react";
import Switch from "@mui/material/Switch";
import { green } from "@mui/material/colors";
import { alpha, styled } from "@mui/material/styles";

export default function SwitchLayer({
  name,
  setLayerName,
  setSwitchIsOn,
  bounds,
  setBoundingBox,
  checkedAll,
  setCheckedAll,
  setLayersThatWereSwitchedNames,
  nameThatWasSwitched,
  layersThatWereSwitchedNames,
  activeLayers,
  setActiveLayers,
}) {
  const [checked, setChecked] = React.useState(false);
  // console.log(name, "layername");

  // console.log(layersThatWereSwitchedNames, "layersThatWereSwitchedNames");
  // console.log(activeLayers, "activeLayers");

  /**
   * This function sets the switch to on or off depending on the target event
   * @param {*} event
   */
  const handleChange = (event) => {
    // console.log("change is good");
    setChecked(event.target.checked);
    // console.log(event.target.checked);
  };

  React.useEffect(() => {
    if (!checkedAll) {
      setChecked(checkedAll);
      setCheckedAll(null);
    }
  }, [checkedAll]);

  const GreenSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: green[600],
      "&:hover": {
        backgroundColor: alpha(green[600], theme.palette.action.hoverOpacity),
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: green[600],
    },
  }));
  /**
   * This function is called when the switch is turned on and if the value is true it adds the layer named to the map
   * @param {*} checked
   */
  const addLayer = (checked) => {
    // console.log("bike edw");
    if (!checked) {
      if (Array.isArray(layersThatWereSwitchedNames)) {
        // Remove the name from the array if it was switched off
        const updatedSwitchedNames = layersThatWereSwitchedNames.filter(
          (switchedName) => switchedName !== nameThatWasSwitched
        );
        setLayersThatWereSwitchedNames(updatedSwitchedNames);
        console.log(layersThatWereSwitchedNames, "layersThatWereSwitchedNames");
      }
      setSwitchIsOn(false);
      setLayerName(name);

      // console.log(`we remove ${name} layer`);
    } else {
      setSwitchIsOn(false);

      setSwitchIsOn(true);
      setLayerName(name);
      if (Array.isArray(layersThatWereSwitchedNames)) {
        const updatedSwitchedNames = [
          ...layersThatWereSwitchedNames,
          nameThatWasSwitched,
        ];
        setLayersThatWereSwitchedNames(updatedSwitchedNames);
      }
      setBoundingBox(bounds);
      // console.log(`we add ${name} layer`);
    }
  };
  React.useEffect(() => {
    if (Array.isArray(activeLayers) && activeLayers.includes(name)) {
      setChecked(true);
      // console.log(name, "layer is set to ", checked);
    }
  }, []);

  return (
    <div className={`${name}-switch`}>
      <GreenSwitch
        checked={checked}
        onChange={(e) => {
          // console.log(!checked);
          handleChange(e);
          addLayer(!checked);
        }}
        inputProps={{ "aria-label": "controlled" }}
      />
    </div>
  );
}
